module.exports = __webpack_public_path__ + "img/la_bellenergie_80X30.4317d123.png";